/**
 * User api script class
 *
 * @package    Api
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com Commercial
 * @link       http://mindk.com
 */

export default class UserApi {
    /**
     * Send request for store user
     * @param data
     * @returns {Object}
     */
    static storeUser(data) {
        return axios => axios.post('/users', data);
    }

    /**
     * Update email
     *
     * @param id
     * @param data
     * @returns {function(*)}
     */
    static updateUser(id, data) {
        return axios => axios.patch(`/users/${id}`, data);
    }

    /**
     * Get user information
     *
     * @param id
     * @returns {function(*): *}
     */
    static loadUserData(id) {
        return axios => axios.get(`/users/${id}`);
    }

    /**
     * Find all instances of the model matched by filter from the data source
     *
     * @param filter
     * @returns {Object}
     */
    static find(filter) {
        return axios => axios.get('/users', { filter });
    }

    /**
     * @returns {Object}
     */
    static findRoles() {
        return axios => axios.get('/roles');
    }

    /**
     * @param filter
     * @returns {Object}
     */
    static findJournals(filter) {
        return axios => axios.get('/journals', { filter });
    }
}



// WEBPACK FOOTER //
// ./src/api/user.js